import React from 'react';
import { TicketDetailsLayout } from '@/components/ticket-details/TicketDetailsLayout';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

/**
 * Ticket Details Page Component
 * 
 * Professional three-column layout for ticket details
 * Following Freshdesk patterns with Webcoda design system integration
 */
export function TicketDetails() {
  useDocumentTitle('Ticket | SupportDesk');
  return <TicketDetailsLayout />;
}